import { Dispatch } from "react";

// Three-tier role model (see database.rules.json for what each may do):
//   admin (< 5) > presenter (onboarded hosts) > audience (everyone else).
// '' = role not loaded yet (users/{uid} fetch still in flight).
export type Role = 'admin' | 'presenter' | 'audience' | '';

// Roles that can host: create quizzes, run sessions. Admin additionally
// manages the catalog and onboards presenters.
export const isHostRole = (role: string): boolean =>
    role === 'admin' || role === 'presenter';

type UserInfo = {
    name: string,
    email: string,
    photoURL: string,
    role: Role,
    // Curated leaderboard emoji (constants/avatars.ts), persisted at join like
    // the nickname — the same face shows up on next week's board.
    avatar?: string,
    createdAt: string,
    lastLogin: string
}

export type AuthContextType = {
    token: string | null,
    setToken: Dispatch<any>,
    user: string | null,
    setUser: Dispatch<any>,
    userInfo: UserInfo,
    setUserInfo: Dispatch<any>,
    loginViaGoogle: (auth: any) => void,
    auth: any,
    logout: () => void
}
